<div
  #container
  (@panelState.done)="onAnimationEnd($event)"
  (@panelState.start)="onAnimationStart($event)"
  *ngIf="visible"
  [@panelState]="{
    value: 'visible',
    params: { transform: transformOptions, transition: transitionOptions }
  }"
  [attr.aria-modal]="modal"
  [class]="styleClass"
  [ngClass]="{
    'p-sidebar': true,
    'p-sidebar-active': visible,
    'p-sidebar-left': position === 'left' && !fullScreen,
    'p-sidebar-right': position === 'right' && !fullScreen,
    'p-sidebar-top': position === 'top' && !fullScreen,
    'p-sidebar-bottom': position === 'bottom' && !fullScreen,
    'p-sidebar-full': fullScreen
  }"
  [ngStyle]="style"
  role="complementary"
>
  <div class="p-sidebar-header">
    <button
      (click)="close($event)"
      (keydown.enter)="close($event)"
      *ngIf="showCloseIcon"
      [attr.aria-label]="ariaCloseLabel"
      class="p-sidebar-close p-sidebar-icon p-link"
      pRipple
      type="button"
    >
      <span class="p-sidebar-close-icon pi pi-times"></span>
    </button>
  </div>
  <div class="p-sidebar-content">
    <ng-content></ng-content>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
</div>
